import { Box, Button, Flex, Image } from '@chakra-ui/react'
import React from 'react'

import Typical from 'react-typical'

import {FaArrowDown} from "react-icons/fa"
import { HashLink } from 'react-router-hash-link'

import "./Home.css"

function Home() {
  return  (
    <div id='/' className='homeclass'>
             
        <Box id='homeBox' className='homeBox' width={'100%'} margin='auto'  marginTop={4} color='white'  pt={"180px"}
        >
            <Flex id='homename' marginTop={10} flexDirection={'column'}  width={'60%'}  >
                    <Box className='nameHome'
                      // fontSize='40px'
                      >
                        <h2>Hi There,<br/> I'm Kiran <span>Wankhade</span></h2>
                    </Box>
                   
                    <Box>
                      <Box className='nameHome'>
                          <Typical
                            steps={['I am ', 1000,'I am A Full Stack Developer', 1000]}
                            loop={Infinity}
                            wrapper="p"
                          />
                      </Box>
                    </Box>
                    <Flex gap={5} flexDirection={'column'} alignItems='center'>
                        <HashLink to="#contact"><Button background="orange" color={'black'} fontWeight='bold'  marginTop={2} _hover={{color:'black' ,bg:'yellow'}}>Contact Me <span style={{marginLeft:'10px'}}> <FaArrowDown/></span></Button></HashLink>
                        <Flex flexDirection={'row'} gap={5} alignItems='center'>
                          <a href='https://www.linkedin.com/in/kiranwankhade/' target={'_blank'} rel="noreferrer"><Image borderRadius={10} h={'35px'}  src='https://image.similarpng.com/very-thumbnail/2020/07/Linkedin-logo-transparent-PNG.png' alt='LinkeIn'/></a>
                          <a href='https://github.com/kiranwankhade' target={'_blank'} rel="noreferrer"><Image borderRadius={10} h={'35px'}  src='https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png' alt='Github'/></a>
                        </Flex>
             </Flex> 
            </Flex>
        </Box><br/>
    </div>
  )
}

export default Home